// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3EKeC","header":"ReportDetails_header__1DzZT","title":"ReportDetails_title__1rUVZ","left":"ReportDetails_left__3ECY9"};